import { Injectable } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { Router } from "@angular/router";
import {
  QueryParams,
  hasValue,
  setQueryVarsFromPaginator,
} from "common";

@Injectable()
export class FacilityListFacade {
  constructor(private readonly router: Router) {
  }

  filter(paginator?: MatPaginator): void {
    const query = new QueryParams();

    query.skip = undefined;

    if (hasValue(paginator)) {
      setQueryVarsFromPaginator(query, paginator);
    }

    void this.router.navigate([], {
      queryParams: query,
    });
  }
}
